/**
 * Hero entrance animation: decorative slashes, then the wordmark, then the
 * pet visual floating upward, then the bottom bar (CTA last) — matches the
 * resting opacity values already defined in the hero's own stylesheet, so
 * this only adds a load-time animation, not a visual/design change.
 *
 * The pet visual animates opacity + y (translateY) only — no scale — so
 * it's a single GPU-composited transform instead of one that also forces
 * the browser to recompute the element's paint bounds every tick.
 */
import { motionEnabled } from '@theme/premium-motion';

const hero = document.querySelector('.flv-hero');

if (hero) {
  const slashes = hero.querySelectorAll('.flv-hero__slash');
  const wordmark = hero.querySelector('.flv-hero__wordmark');
  const petImage = hero.querySelector('.flv-hero__pet-media--active');
  const bottom = hero.querySelector('.flv-hero__bottom');

  if (motionEnabled && typeof gsap !== 'undefined') {
    gsap.set(slashes, { opacity: 0, y: 12 });
    gsap.set(wordmark, { opacity: 0, y: 28 });
    if (petImage) gsap.set(petImage, { opacity: 0, y: 40 });
    if (bottom) gsap.set(bottom, { opacity: 0, y: 16 });

    const timeline = gsap.timeline({ defaults: { ease: 'power2.inOut' } });
    timeline
      .to(slashes, { opacity: 0.6, y: 0, duration: 0.6, stagger: 0.1 })
      .to(wordmark, { opacity: 0.85, y: 0, duration: 0.75 }, '-=0.4');

    if (petImage) timeline.to(petImage, { opacity: 1, y: 0, duration: 0.8 }, '-=0.5');
    if (bottom) timeline.to(bottom, { opacity: 1, y: 0, duration: 0.7 }, '-=0.3');
  }
}
